import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { PackageSalesByTemplateItemDTO } from "../api/client";

type PackageSalesReportTableProps = {
  isLoading: boolean;
  data: PackageSalesByTemplateItemDTO[];
};

const PACKAGE_TYPE_LABELS: Record<string, string> = {
  package: "ແພັກເກດຄລາດສ໌",
  private_lesson: "ແພັກເກດຮຽນສ່ວນຕົວ",
};

export function PackageSalesReportTable({
  isLoading,
  data,
}: PackageSalesReportTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[220px]">ຊື່ແພັກເກດ</TableHead>
            <TableHead className="w-[140px]">ປະເພດ</TableHead>
            <TableHead className="w-[120px] text-right">ຈຳນວນທີ່ຂາຍ</TableHead>
            <TableHead className="w-[140px] text-right">ຍອດຂາຍ</TableHead>
            <TableHead className="min-w-[180px]">ປະເພດຄລາດສ໌ / ລະດັບ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => (
              <TableRow key={`${row.packageType}-${row.templateId}`}>
                <TableCell className="font-medium">
                  {row.templateName}
                </TableCell>
                <TableCell className="text-muted-foreground text-sm">
                  {PACKAGE_TYPE_LABELS[row.packageType] ?? row.packageType}
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.salesCount.toLocaleString()}
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.revenue.toLocaleString("lo-LA")} ກີບ
                </TableCell>
                <TableCell className="text-muted-foreground text-sm">
                  {row.packageType === "package" &&
                  (row.classTypes?.length || row.levels?.length) ? (
                    <span>
                      {row.classTypes?.join(", ")}
                      {row.classTypes?.length && row.levels?.length
                        ? " / "
                        : ""}
                      {row.levels?.join(", ")}
                    </span>
                  ) : (
                    "—"
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
